import FigureProject from "./FigureProject.Container";

export default FigureProject;